@if (hasOptionalReview) {
	<details class="rea-section rea-review-details" [open]="reviewReasons.length > 0">
		<summary>Revisión recomendada</summary>

		@if (reviewReasons.length > 0) {
			<div class="rea-review-block">
				<div class="rea-section__header rea-section__header--action">
					<div>
						<h4>{{ reviewHeadline }}</h4>
						<p class="rea-section__hint">Antes de dar la importación por buena, revisa estos puntos.</p>
						@if (reviewRequiredLabel) {
							<p class="rea-review-alignment">{{ reviewRequiredLabel }}</p>
						}
					</div>

					<p-button
						type="button"
						label="Revisar parcelas"
						icon="pi pi-search"
						severity="warn"
						[outlined]="true"
						(onClick)="requestReview()"
					></p-button>
				</div>

				<div class="rea-review-reasons">
					@for (reason of reviewReasons; track reason.key) {
						<div class="rea-review-reason">
							<span class="rea-review-reason__count">{{ reason.count }}</span>
							<div class="rea-review-reason__content">
								<div class="rea-review-reason__step">
									<span>Qué revisar</span>
									<b>{{ reason.label }}</b>
								</div>

								<div class="rea-review-reason__step">
									<span>Por qué</span>
									<small>{{ reason.description }}</small>
								</div>

								<div class="rea-review-reason__step">
									<span>Qué hacer</span>
									<small>{{ reason.recommendedAction }}</small>
								</div>
							</div>
						</div>
					}
				</div>
			</div>
		}

		@if (hasMapInsights) {
			<div class="rea-review-block">
				<div class="rea-section__header">
					<div>
						<h4>Mapa y parcelas para revisar</h4>
						<p class="rea-section__hint">Capas sugeridas para revisar visualmente las parcelas que requieren comprobación.</p>
					</div>
					<p-tag [value]="suggestedMapLayers.length + ' capas'" severity="info" [rounded]="true"></p-tag>
				</div>

				<div class="rea-map-layers">
					@for (layer of suggestedMapLayers; track layer.key) {
						<div class="rea-map-layer">
							<span class="rea-map-layer__count">{{ layer.count }}</span>
							<div>
								<b>{{ layer.label }}</b>
								<small>{{ layer.description }}</small>
							</div>
						</div>
					}
				</div>
			</div>
		}

		@if (changesTruncated) {
			<p-message
				severity="info"
				text="Se muestran solo los primeros cambios. El detalle completo está disponible en la auditoría."
			></p-message>
		}

		@if (visibleRecentChanges.length > 0) {
			<div class="rea-review-block">
				<div class="rea-section__header">
					<h4>Cambios relevantes</h4>
					<p-tag [value]="visibleRecentChanges.length + ' mostrados'" severity="info" [rounded]="true"></p-tag>
				</div>

				@if (visibleChangeDigestMetrics.length > 0) {
					<div class="rea-change-digest">
						@for (item of visibleChangeDigestMetrics; track item.label) {
							<span><b>{{ item.value }}</b> {{ item.label }}</span>
						}
					</div>
				}

				<ul class="rea-list rea-list--changes">
					@for (change of visibleRecentChanges; track change.code) {
						<li>
							<i class="pi pi-refresh" aria-hidden="true"></i>
							<div>
								<b>{{ change.label || change.code }}</b>
								@for (message of change.messages; track message) {
									<span>{{ message }}</span>
								}

								@if (hasFieldChanges(change)) {
									<div class="rea-field-changes">
										@for (fieldChange of fieldChangesFor(change); track fieldChange.field) {
											<span class="rea-field-change">
												<b>{{ fieldChange.label }}</b>
												<small>{{ fieldChange.before }} → {{ fieldChange.after }}</small>
											</span>
										}
									</div>
								}
							</div>
						</li>
					}
				</ul>
			</div>
		}
	</details>
}
